import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { Grid as SemanticGrid, Header } from 'semantic-ui-react'
import Grid from 'components/grids/Grid'
import ICONS from 'helpers/icons'
import { withElementsState } from 'store/elements/elementHocs'
import IconCard from 'components/Card/IconCard'

const GeneralElements = compose(
  withElementsState(),
)(
  ({
    elements,
    currentElement,
    onSelectElement,
  }) => {
    const rows = [
      ['Layout', 'Basic', 'Typography', 'Component'],
      ['Product', 'Social Media'],
    ]
    return (
      <SemanticGrid divided style={{ marginTop: 20 }}>
        {rows.map((categories) => (
          <SemanticGrid.Row>
            {categories.map((category) => {
              const filteredElements = elements.filter((item) => item.category === category)
              return (
                <Grid.Column key={category} width={3}>
                  <Header content={category} as="h4" textAlign="center" />
                  <Grid gutter={0.5}>
                    {filteredElements.map((element) => {
                      const { name, refElement } = element
                      const isActive = (
                        currentElement && currentElement.refElement === refElement
                      )
                      return (
                        <Grid.Column
                          width={6}
                          key={element.refElement}
                        >
                          <IconCard
                            onClick={() => onSelectElement(element)}
                            isActive={isActive}
                            caption={name}
                            icon={ICONS[refElement]}
                          />
                        </Grid.Column>
                      )
                    })}
                  </Grid>
                </Grid.Column>
              )
            })}
          </SemanticGrid.Row>
        ))}
      </SemanticGrid>
    )
  }
)

GeneralElements.propTypes = {
  elements: PropTypes.array,
}
GeneralElements.defaultProps = {
  elements: [],
}

export default GeneralElements



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/selectors/GeneralElements.js